import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class LoadingIndicatorService {
  // Induláskor false, vagyis nincs loading
  private _isLoading$ = new BehaviorSubject<boolean>(false)
  // Ebből adunk ki egy "csak olvasható" observable-t a komponenseknek
  isLoading$ = this._isLoading$.asObservable()

  private lastShowTimestamp = 0
  private minimumDurationMs = 1000

  showLoading(): void {
    this._isLoading$.next(true)
    this.lastShowTimestamp = Date.now()
  }

  hideLoading(): void {
    const now = Date.now()
    const elapsed = now - this.lastShowTimestamp
    if (elapsed < this.minimumDurationMs) {
      const remaining = this.minimumDurationMs - elapsed
      setTimeout(() => {
        this._isLoading$.next(false)
      }, remaining)
    } else {
      this._isLoading$.next(false)
    }
  }
}
